export default __webpack_public_path__ + "static/auto-fibonacci-998bbe9dd74062ae2cdf97c4bf7308e8.png";